import { useFormTranslateErrors } from '../../../helpers/useFormTranslateErrors';
import { FormTranslateErrorsProps } from './FormTranslateErrors.types';

/**
 * Allows for validation errors to be translated.
 *
 * @note Can only be used within a Formik context.
 *
 * @param children - {@link FormTranslateErrorsProps.children children} description.
 */
const FormTranslateErrors = ({
    children,
}: FormTranslateErrorsProps) => {
    useFormTranslateErrors();

    return (
        <>
            {children}
        </>
    );
};

export default FormTranslateErrors;